module.exports = __webpack_public_path__ + "static/media/dad_reading.c6e9e869.svg";